// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { xLayerTestnet as _xLayerTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the xLayerTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 195
 * Chain Name: X1 Testnet
 * Default Block Explorer: https://www.oklink.com/xlayer-test
 * Default RPC URL: https://xlayertestrpc.okx.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { xLayerTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: xLayerTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const xLayerTestnet = createCommon({
	..._xLayerTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
